import React from 'react'
import { useTranslation } from 'react-i18next'
import { Checkbox } from '@carsys/form'
import { useFeature } from '@cbgms/base/feature-flags'

export const MockResponseDataToggle: React.FC<{}> = () => {
  const { t } = useTranslation()
  const useMockDataFeature = useFeature('b2b-enable-response-mocking')

  return useMockDataFeature ? (
    <Checkbox name='UseMockData' label={t('wholesale.use_mock_data')} title={t('wholesale.use_mock_data_title')} />
  ) : null
}

export default MockResponseDataToggle
